import React from "react";
import "./styles.css";

const ARIcon = ({ isActive, handleClick }) => {
  return (
    <div className="icon-container icon-margin-right" id="invite">
      <a className="icon-anchor" onClick={handleClick}>
        <svg
          className="svg-container element-icon"
          width="100%"
          height="100%"
          viewBox="0 0 512 512"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          xmlSpace="preserve"
          xmlnsserif="http://www.serif.com/"
        >
          <g transform="matrix(1.79021,0,0,1.79021,53.7063,19.6923)">
            <circle className={`el-circle ${isActive ? "active" : ""}`} cx="113" cy="132" r="143" />
          </g>

          <g transform="matrix(13.0411,0,0,13.0411,99.507,99.507)">
            <path
              className="el-path"
              d="M3,5C2.735,5 2.48,5.105 2.293,5.293C2.105,5.48 2,5.735 2,6L2,18C2,18.265 2.105,18.52 2.293,18.707C2.48,18.895 2.735,19 3,19L21,19C21.265,19 21.52,18.895 21.707,18.707C21.895,18.52 22,18.265 22,18L22,6C22,5.735 21.895,5.48 21.707,5.293C21.52,5.105 21.265,5 21,5L3,5ZM0.879,3.879C1.441,3.316 2.204,3 3,3L21,3C21.796,3 22.559,3.316 23.121,3.879C23.684,4.441 24,5.204 24,6L24,18C24,18.796 23.684,19.559 23.121,20.121C22.559,20.684 21.796,21 21,21L3,21C2.204,21 1.441,20.684 0.879,20.121C0.316,19.559 0,18.796 0,18L0,6C0,5.204 0.316,4.441 0.879,3.879ZM14,8C14,7.448 14.448,7 15,7L17,7C17.796,7 18.559,7.316 19.121,7.879C19.684,8.441 20,9.204 20,10C20,10.796 19.684,11.559 19.121,12.121C18.82,12.423 18.461,12.653 18.07,12.803L19.832,15.445C20.138,15.905 20.014,16.526 19.555,16.832C19.095,17.138 18.474,17.014 18.168,16.555L16,13.303L16,16C16,16.552 15.552,17 15,17C14.448,17 14,16.552 14,16L14,8ZM16.318,11L16,11L16,9L17,9C17.265,9 17.52,9.105 17.707,9.293C17.895,9.48 18,9.735 18,10C18,10.265 17.895,10.52 17.707,10.707C17.52,10.895 17.265,11 17,11C17,11 16.328,11 16.318,11ZM10.064,16.351C10.258,16.868 10.834,17.13 11.351,16.936C11.868,16.742 12.13,16.166 11.936,15.649L8.936,7.649C8.79,7.259 8.417,7 8,7C7.583,7 7.21,7.259 7.064,7.649L4.064,15.649C3.87,16.166 4.132,16.742 4.649,16.936C5.166,17.13 5.742,16.868 5.936,16.351L8,10.848L10.064,16.351Z"
            />
          </g>
        </svg>
        {!isActive && (
          <div className="tooltip-btm">
            <p>Enter AR</p>
            <div className="triangle-btm"></div>
          </div>
        )}
      </a>
    </div>
  );
};
export default ARIcon;
